module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_j_leucistic.296a3d7d.png";